import { ShopperAgentSandboxMessageSchema } from "@redotech/redo-model/shopper-agent/sandbox/sandbox-message";
import { TriggerKeySchema } from "@redotech/redo-model/shopper-agent/trigger-definition";
import * as z from "zod";

export const generateSandboxTrigger = {
  name: "generateSandboxTrigger" as const,
  input: z
    .object({
      threadId: z.string().nullable(),
      customerId: z.string(),
      triggerKey: TriggerKeySchema,
    })
    .strict(),
  output: z.object({
    threadId: z.string(),
    messages: z.array(ShopperAgentSandboxMessageSchema),
  }),
};
